module.exports = __webpack_public_path__ + "img/ws.14b82a06.svg";